"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIndicatorBox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.LoadingIndicatorBox = styled_components_1.default.div `
  background: linear-gradient(to top, rgb(186, 186, 186), rgb(245, 245, 245));

  border: 1px solid rgb(112, 131, 148);
  border-radius: 3px;

  box-sizing: border-box;
  padding: 10px 15px 15px 15px;
`;
//# sourceMappingURL=box.js.map